module.exports = __webpack_public_path__ + "static/img/hala23.b91308b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala23.jpg
// module id = 40d6
// module chunks = 1